import React from "react";
import { FaBell, FaEnvelope, FaTimes } from "react-icons/fa";

import {
  formatReminderDateTime,
  getArticleName,
  getReminderHistory,
  getUserFullName,
} from "../utils/paymentsDashboardUtils";

export default function PaymentReminderHistoryDrawer({
  isOpen,
  payment,
  onClose,
}) {
  if (!isOpen || !payment) return null;

  const reminders = getReminderHistory(payment);
  const userName = getUserFullName(payment.User);
  const articleName = getArticleName(payment);

  return (
    <div className="fixed inset-0 z-[9999]">
      <div
        className="absolute inset-0 bg-slate-950/50 backdrop-blur-sm"
        onClick={onClose}
        aria-hidden
      />

      <aside className="absolute right-0 top-0 flex h-full w-full max-w-xl flex-col overflow-hidden bg-white shadow-2xl dark:bg-slate-900">
        <div className="h-1.5 bg-gradient-to-r from-amber-500 via-orange-500 to-rose-500" />

        <div className="flex items-start justify-between gap-4 border-b border-slate-200 p-5 dark:border-slate-800">
          <div>
            <p className="text-[11px] uppercase tracking-[0.22em] text-amber-600 dark:text-amber-300">
              Relances paiement
            </p>

            <h2 className="mt-1 flex items-center gap-2 text-xl font-bold text-slate-900 dark:text-white">
              <FaBell className="text-amber-500" />
              Historique des rappels
            </h2>

            <p className="mt-2 text-sm leading-6 text-slate-600 dark:text-slate-300">
              {userName}
              {payment.User?.email ? ` · ${payment.User.email}` : ""}
            </p>
          </div>

          <button
            type="button"
            onClick={onClose}
            className="flex h-10 w-10 shrink-0 items-center justify-center rounded-2xl border border-slate-200 bg-white text-slate-700 transition hover:bg-slate-50 dark:border-slate-700 dark:bg-slate-900 dark:text-slate-200 dark:hover:bg-slate-800"
            aria-label="Fermer"
          >
            <FaTimes />
          </button>
        </div>

        <div className="min-h-0 flex-1 space-y-5 overflow-y-auto p-5">
          <div className="rounded-[24px] border border-slate-200 bg-slate-50 p-4 dark:border-slate-800 dark:bg-slate-950">
            <p className="text-[11px] uppercase tracking-[0.16em] text-slate-500 dark:text-slate-400">
              Paiement concerné
            </p>

            <p className="mt-2 text-base font-bold text-slate-900 dark:text-white">
              {articleName}
            </p>

            <p className="mt-1 text-sm text-slate-600 dark:text-slate-300">
              Total des rappels envoyés :{" "}
              <span className="font-bold text-amber-700 dark:text-amber-300">
                {reminders.length}
              </span>
            </p>
          </div>

          {reminders.length === 0 ? (
            <div className="rounded-[24px] border border-dashed border-slate-300 bg-white p-6 text-center dark:border-slate-700 dark:bg-slate-950">
              <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-2xl bg-amber-50 text-amber-600 dark:bg-amber-500/10 dark:text-amber-300">
                <FaEnvelope />
              </div>

              <h3 className="mt-4 text-base font-bold text-slate-900 dark:text-white">
                Aucun rappel envoyé
              </h3>

              <p className="mt-2 text-sm leading-6 text-slate-600 dark:text-slate-300">
                Dès qu’un mail de relance sera envoyé, sa date apparaîtra ici.
              </p>
            </div>
          ) : (
            <div className="space-y-3">
              {reminders
                .slice()
                .reverse()
                .map((reminder, index) => {
                  const reminderNumber = reminders.length - index;

                  return (
                    <article
                      key={`${reminder.sent_at || "reminder"}-${index}`}
                      className="rounded-[22px] border border-slate-200 bg-white p-4 shadow-sm dark:border-slate-800 dark:bg-slate-950"
                    >
                      <div className="flex items-start justify-between gap-3">
                        <div>
                          <p className="text-sm font-bold text-slate-900 dark:text-white">
                            Rappel #{reminderNumber}
                          </p>

                          <p className="mt-1 text-xs text-slate-500 dark:text-slate-400">
                            {formatReminderDateTime(reminder.sent_at)}
                          </p>
                        </div>

                        <span className="inline-flex rounded-full bg-amber-50 px-2.5 py-1 text-[11px] font-bold uppercase tracking-wide text-amber-700 ring-1 ring-amber-200 dark:bg-amber-500/10 dark:text-amber-300 dark:ring-amber-500/20">
                          {reminder.channel || "email"}
                        </span>
                      </div>

                      {reminder.subject ? (
                        <p className="mt-3 rounded-2xl bg-slate-50 p-3 text-xs leading-5 text-slate-600 dark:bg-slate-900 dark:text-slate-300">
                          {reminder.subject}
                        </p>
                      ) : null}
                    </article>
                  );
                })}
            </div>
          )}
        </div>

        <div className="border-t border-slate-200 bg-white p-4 dark:border-slate-800 dark:bg-slate-900">
          <button
            type="button"
            onClick={onClose}
            className="inline-flex w-full items-center justify-center gap-2 rounded-2xl bg-slate-900 px-4 py-3 text-sm font-bold text-white transition hover:bg-slate-700 dark:bg-white dark:text-slate-900 dark:hover:bg-slate-200"
          >
            <FaTimes />
            Fermer
          </button>
        </div>
      </aside>
    </div>
  );
}